'use client'

import React, { ReactElement, useContext, useState } from 'react'
import { useWizardSelector } from '@/components/ui/wizard/WizardState'
import { useDispatch } from 'react-redux'
import DropDown from '@/components/ui/wizard/filter/DropDown'
import SelectOptions from '@/components/ui/wizard/filter/SelectOptions'
import { ConfigContext } from '@/components/common/ConfigContext'
import { setLocationFilter } from '@/components/ui/wizard/WizardActions'
import { useTranslations } from 'next-intl'

export function LocationDropdown(): ReactElement {
  const config = useContext(ConfigContext)!
  const locationFilterInStore = useWizardSelector((state) => state.locationFilter)
  const [locationFilter, setLocationFilterLocalState] = useState(locationFilterInStore)
  const dispatch = useDispatch()
  const t = useTranslations('SearchPage')

  return (
    <DropDown
      reset={() => setLocationFilterLocalState([])}
      apply={() => dispatch(setLocationFilter(locationFilter))}
      resetLabel={t('filterOptionReset')}
      id="order"
      rightAligned={true}
    >
      <SelectOptions
        selectedLocationFilter={locationFilter}
        setLocationFilterLocalState={setLocationFilterLocalState}
        options={{ landscape: config.searchFilters.location }}
        inDropDown={true}
      />
    </DropDown>
  )
}
